function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "noun_Trash_3465742");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Ecommerce-NoFood",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop/4.0---MS_Nofood---Cart",
  transform: "translate(-181.000000, -342.000000)",
  fill: "#858585",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(50.000000, 208.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(131.000000, 134.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.56734007,3.83870968 C1.32014815,3.83870968 1.11952862,4.04103226 1.11952862,4.29032258 L1.11952862,10.8387097 C1.11952862,12.640871 2.37093771,14 4.03030303,14 L8.06060606,14 C9.71997138,14 10.9713805,12.640871 10.9713805,10.8387097 L10.9713805,4.29032258 C10.9713805,4.04103226 10.7707609,3.83870968 10.523569,3.83870968 C10.2763771,3.83870968 10.0757576,4.04103226 10.0757576,4.29032258 L10.0757576,10.8387097 C10.0757576,12.1470323 9.22827441,13.0967742 8.06060606,13.0967742 L4.03030303,13.0967742 C2.86263468,13.0967742 2.01515152,12.1470323 2.01515152,10.8387097 L2.01515152,4.29032258 C2.01515152,4.04103226 1.81453199,3.83870968 1.56734007,3.83870968 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.447811448,3.16129032 L4.03030303,3.16129032 L8.06060606,3.16129032 L11.6430976,3.16129032 C11.8902896,3.16129032 12.0909091,2.95896774 12.0909091,2.70967742 C12.0909091,2.4603871 11.8902896,2.25806452 11.6430976,2.25806452 L8.50841751,2.25806452 L8.50841751,0.451612903 C8.50841751,0.202322581 8.30779798,0 8.06060606,0 L4.03030303,0 C3.78311111,0 3.58249158,0.202322581 3.58249158,0.451612903 L3.58249158,2.25806452 L0.447811448,2.25806452 C0.200619529,2.25806452 0,2.4603871 0,2.70967742 C0,2.95896774 0.200619529,3.16129032 0.447811448,3.16129032 Z M4.47811448,0.903225806 L7.61279461,0.903225806 L7.61279461,2.25806452 L4.47811448,2.25806452 L4.47811448,0.903225806 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.06060606,10.6129032 L8.06060606,5.87096774 C8.06060606,5.62167742 7.85998653,5.41935484 7.61279461,5.41935484 C7.36560269,5.41935484 7.16498316,5.62167742 7.16498316,5.87096774 L7.16498316,10.6129032 C7.16498316,10.8621935 7.36560269,11.0645161 7.61279461,11.0645161 C7.85998653,11.0645161 8.06060606,10.8621935 8.06060606,10.6129032 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.92592593,10.6129032 L4.92592593,5.87096774 C4.92592593,5.62167742 4.7253064,5.41935484 4.47811448,5.41935484 C4.23092256,5.41935484 4.03030303,5.62167742 4.03030303,5.87096774 L4.03030303,10.6129032 C4.03030303,10.8621935 4.23092256,11.0645161 4.47811448,11.0645161 C4.7253064,11.0645161 4.92592593,10.8621935 4.92592593,10.6129032 Z",
  id: "Path"
})))));

var SvgDeleteIcon = function SvgDeleteIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "14px",
    viewBox: "0 0 13 14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete_icon.408fd0af.svg";
export { ForwardRef as ReactComponent };